/**
 * Dev Mail - Delete Command
 * Delete a temp email account
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { confirm } from '@inquirer/prompts';
import { ConfigService } from '../../../services/config.service.js';
import { TempMailApiService } from '../../../services/temp-mail.service.js';

interface DeleteOptions {
    yes?: boolean;
    json?: boolean;
}

async function handleDelete(address: string, options: DeleteOptions): Promise<void> {
    const config = await new ConfigService().load();
    if (!config) {
        console.error('❌ Not initialized. Run "jai1 auth" first.');
        process.exit(1);
    }

    if (!options.yes && !options.json) {
        const confirmed = await confirm({
            message: `Xóa account ${chalk.cyan(address)}? Hành động không thể hoàn tác.`,
            default: false,
        });
        if (!confirmed) {
            console.log(chalk.dim('❌ Đã hủy.'));
            return;
        }
    }

    const api = new TempMailApiService(config);

    if (!options.json) {
        console.log(chalk.dim('⏳ Đang xóa account...'));
    }

    const result = await api.deleteAccount(address);

    if (!result.success) {
        if (options.json) {
            console.log(JSON.stringify({ success: false, error: result.error }));
        } else {
            console.error(`❌ ${result.error}`);
        }
        process.exit(1);
    }

    if (options.json) {
        console.log(JSON.stringify({ success: true }));
        return;
    }

    console.log(`✅ Đã xóa account: ${chalk.cyan(address)}`);
}

export function createMailDeleteCommand(): Command {
    return new Command('delete')
        .description('Xóa một temp email account')
        .argument('<address>', 'Địa chỉ email cần xóa')
        .option('-y, --yes', 'Bỏ qua xác nhận')
        .option('-j, --json', 'Output dạng JSON')
        .addHelpText('after', `
Examples:
  $ j dev mail delete user@dollicons.com
  $ j dev mail delete user@dollicons.com -y
  $ j dev mail delete user@dollicons.com -j
`)
        .action(async (address: string, options: DeleteOptions) => {
            await handleDelete(address, options);
        });
}
